import React, { useRef } from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component'

function CustomButtonGroup({ carouselRef }) {


    const handlePrevClick = () => {
        if (carouselRef.current) {
            carouselRef.current.previous();
        }
    };

    const handleNextClick = () => {
        if (carouselRef.current) {
            carouselRef.current.next();
        }
    };


    return (
        <div className='flex flex-row gap-2'>
            <LazyLoadImage onClick={handleNextClick}
                loading="lazy"
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/087b5804b489374c6fdc0650bb473746ad951b24ca36254bff669df4e7a01356?"
                className="self-stretch my-auto w-9 aspect-square cursor-pointer"
            />
            <LazyLoadImage id="test" onClick={handlePrevClick}
                loading="lazy"
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/f55607e50c067a850abba8f929e22caa007077e45368dde87d58c901d65d1804?"
                className="self-stretch my-auto w-6 aspect-square cursor-pointer"
            />
        </div>
    )
}

export default CustomButtonGroup